import api from './index'

class MemberService {
	getMembers(params) {
		return api.get('/members', { params })
	}
	getMemberInfo(id, credit = '') {
		return api.get(`/members/${id}`, {
			params: {
				credit,
			},
		})
	}
	saveMember(id, data) {
		return api.post(`/members/${id}`, data)
	}
	addCredit(id, data) {
		return api.post(`/members/${id}/credit`, data)
	}
	updateStatus(id, data) {
		return api.post(`/members/${id}/status`, data)
	}
	getTransactions(memberID, params) {
		return api.get(`/members/${memberID}/transactions`, { params })
	}
	fetchNameFromBankAccount(memberID) {
		return api.get(`/members/${memberID}/bank-account`)
	}
}

export default new MemberService()
